import { type AppState, type Selector } from '../rootReducer';
import { type clusterState } from './types';

export const getStates: Selector<clusterState> = (state: AppState) => state.cluster;
